import { LoadingState } from '../../components/LoadingState/LoadingState'
import type { PageLoadingShellProps } from './PageLoadingShell.types'
import './PageLoadingShell.css'

export function PageLoadingShell({
  loadingLabel,
  isLoading,
  error,
  children,
}: PageLoadingShellProps) {
  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        <strong>Error:</strong> {error}
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="content-card page-loading-shell__loading">
        <LoadingState label={loadingLabel} />
      </div>
    )
  }

  return <>{children}</>
}
